import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { WFAlertHistoryData, WFAlertHistoryRecord } from '../models/WfAlertHistory';
import { sharedStorage } from 'src/common/storage/storage';

interface WfAlertHistoryStore {
  historySearchParams: {
    customerNumber?: string | null | undefined;
    disasterId?: string | null | undefined;
    branchCode?: string | null | undefined;
    buildingName?: string | null | undefined;
    salesOfficeCode?: string | null | undefined;
    organizationCode?: string | null | undefined;
  };
  history: WFAlertHistoryData | null;
  selectedHistory: WFAlertHistoryRecord | undefined;
  patchHistorySearchParams: (
    patch: Partial<{
      disasterId?: string | null | undefined;
      customerNumber?: string | null | undefined;
      branchCode?: string | null | undefined;
      buildingName?: string | null | undefined;
      salesOfficeCode?: string | null | undefined;
      organizationCode?: string | null | undefined;
    }>
  ) => void;
  setSelectedHistory: (selectedHistory: WFAlertHistoryRecord | undefined) => void;
  setHistory: (history: WFAlertHistoryData | null) => void;
}

const ALERT_HISTORY_STORE_KEY = 'wf-alert-history-store';

export const useWfAlertHistoryStore = create<WfAlertHistoryStore>()(
  persist(
    (set) => ({
      historySearchParams: {
        customerNumber: null,
        disasterId: null,
        branchCode: null,
        buildingName: null,
        salesOfficeCode: null,
        organizationCode: null,
      },
      history: null,
      selectedHistory: undefined,
      patchHistorySearchParams: (patch) =>
        set((state) => ({
          historySearchParams: {
            ...state.historySearchParams,
            ...patch,
          },
        })),
      setSelectedHistory: (selectedHistory: WFAlertHistoryRecord | undefined) =>
        set({ selectedHistory }),
      setHistory: (history: WFAlertHistoryData | null) => set({ history }),
    }),
    {
      name: ALERT_HISTORY_STORE_KEY,
      storage: createJSONStorage(() => sharedStorage),
      partialize: (state) => ({
        historySearchParams: state.historySearchParams,
      }),
    }
  )
);
